<template>
  <v-card class="device-list" variant="text" :loading="loading">
    <div>
      <v-text-field v-model="searchText" placeholder="设备名称/UUID" rounded variant="outlined" density="compact"
        append-inner-icon="mdi-magnify" @click:append-inner="onSearch" clearable :select-strategy="selectStrategy"
        color="var(--color-primary)"></v-text-field>
    </div>

    <v-treeview item-props v-model="ids" v-model:activated="act_ids" :search="searchText" :custom-filter="filterDevice"
      open-all @click:select="onSelect" :items="items" item-value="id" density="compact" color="var(--color-primary)"
      style="background: transparent;" :activatable="activatable" @update:activated="onActivated">
      <template v-slot:prepend="{ item, isOpen }">
        <div class="mr-2">
          <v-icon v-if="!item.type" :icon="isOpen ? 'mdi-folder-open' : 'mdi-folder'"></v-icon>
          <Gauge v-else-if="item.type === 'meter'" size="20"></Gauge>
          <TransformerIcon v-else-if="item.type === 'transformer'" size="24"></TransformerIcon>
          <v-icon v-else :icon="icons[item.type]"></v-icon>
        </div>
      </template>
      <template v-slot:title="{ item }">        
        <span v-html="highlightText(item.title, searchText)"></span>
      </template>
      <template #subtitle="{ item }">
        <div v-tooltip:bottom="item.id?.toString()">
          <template v-if="onlineStatus[item.id] !== undefined">
            <span class="status-point" :class="OnLineStatusMap.getClass(onlineStatus[item.id] ? 1 : 0)" v-tooltip="OnLineStatusMap.getText(onlineStatus[item.id] ? 1 : 0)"></span>&nbsp;
          </template>
          <span v-if="item.showId" v-html="highlightText(item.id?.toString(), searchText)"></span>
        </div>
      </template>
    </v-treeview>
  </v-card>
</template>


<script setup>

import { inject, watch, computed, shallowRef, ref, useTemplateRef, onUnmounted } from 'vue'
import { Gauge, Box, Square, Link, Package, SquareStack } from 'lucide-vue-next'
import TransformerIcon from './icons/transformer.vue'
// import { ws_req } from '@/ws/wss-request'
// import { OnLineStatusMap } from '@/utils/statusMaps/online'
import { createStatusMap } from '@/utils'

const OnLineStatusMap = createStatusMap({
  0: { text: '离线', class: 'offline' },
  1: { text: '在线', class: 'online' },
})

const props = defineProps({
  items: {
    type: Array,
    default: () => []
  },
  selectedId: {
    type: Array,
    default: () => []
  },
  activatedId: {
    type: Array,
    default: () => []
  },
  selectStrategy: {
    type: String,
    default: 'single'
  },
  activatable: {
    type: Boolean,
    default: false
  },
  loading: {
    type: Boolean,
    default: false,
  },
  // 在线状态
  onlineStatus: {
    /**
     * @type {{ [key: string]: boolean }}
     * @example
     * {
     *   'uuid1': true,
     *   'uuid2': false,
     * }
     */
    type: Object,
    default: () => ({})
  },
  // getRealDataById: {
  //   type: Function,
  // }
})


const emit = defineEmits(['select', 'search', 'activated', 'update:selectedId', 'update:activatedId'])
const stationId = inject('stationId')

const icons = {
  elink: Link,//'mdi-link',
  eblock: Box,//'mdi-code-block-brackets',
  square: SquareStack,
  galaxy: Package,
}



const searchText = ref('')
const ids = computed({
  get() {
    return props.selectedId
  },
  set(value) {
    emit('update:selectedId', value)
  }
})

const act_ids = computed({
  get() {
    return props.activatedId
  },
  set(value) {
    emit('update:activatedId', value)
  }
})


function onSearch(v) {
  emit('search', searchText.value)
}

async function onSelect(params) {
  emit('select', params)
}

function onActivated(params) {
  emit('activated', params)
}


function filterDevice(value, search, item) {
  const nameInclude = value.toLowerCase().indexOf(search.toLowerCase()) > -1
  const idInclude = item.value?.toString().toLowerCase().indexOf(search.toLowerCase()) > -1
  
  return nameInclude || idInclude
}

function highlightText(text, keyword) {
  if (!keyword || !text) return text
  const regex = new RegExp(`(${keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi')
  return text.replace(regex, '<mark class="highlight-text">$1</mark>')
}


</script>
<style lang="scss" scoped>
.device-list {
  border-radius: 16px;
  // border: 1px solid #DBE8F7;
  width: 329px;
  min-width: 260px;
  max-width: 329px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  // background: #fff linear-gradient(180deg, rgba(245, 250, 255, 0.56) 0%, rgba(255, 255, 255, 0.90) 100%);
  background: #fff;

  :deep(.v-list-item-title) {
    display: flex;
    align-items: center;
  }
}

@media (max-width: 1366px) {
  .device-list {
    width: 280px;
    min-width: 240px;
  }
}

@media (max-width: 1024px) {
  .device-list {
    width: 100%;
    min-width: 0;
    max-width: 100%;
    max-height: 260px;
  }
}

:deep(.highlight-text) {
  background-color: #C1FFD6;
  border-radius: 2px;
}

.status-point {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.status-point.offline {
  background-color: #8995A1;
}

.status-point.online {
  background-color: #4FBC60;
}
</style>
